import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withCookies } from 'react-cookie';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';
import store from '../../store/index';
import { saveUserToStore, logoutUser } from '../../helpers';

const styles = () => ({
  appBar: {
    color: '#fff',
    backgroundColor: '#2096f3',
    boxShadow: 'none',
    borderBottom: '1px solid #eee',
    position: 'relative',
  },
  contentWrapper: {
    maxWidth: 720,
    margin: '0 auto',
  },
  textField: {
    marginLeft: 8,
    marginRight: 8,
    width: '100%',
  },
  saveButton: {
    marginTop: 40,
    width: '100%',
    padding: '16px 32px',
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  deleteButton: {
    marginTop: 40,
    width: '100%',
    padding: '16px 32px',
    color: '#E71133',
    backgroundColor: '#fff',
    boxShadow: 'none',
    '&:hover, &:focus': {
      color: '#B7031F',
      backgroundColor: '#fff',
    },
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class MenuSettingsDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen,
      hash: '', // HACK
      name: '',
      email: '',
      language: 'en_gb',
      isDeletionDialogOpen: false,
      isEmailVerified: true
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleDeletionDialogClose = this.handleDeletionDialogClose.bind(this);
    this.handleDeletionDialogConfirm = this.handleDeletionDialogConfirm.bind(this);
  }

  componentDidMount() {
    this.reloadUserData();

    this.storeSubscription = store.subscribe(() => {
      this.reloadUserData();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.hash === this.state.hash) {
      return;
    }

    this.setState({
      isOpen: this.props.isOpen,
      hash: this.props.hash,
    });
  }

  componentWillUnmount() {
    if (this.storeSubscription) {
      this.storeSubscription();
    }
  }

  reloadUserData() {
    const storeState = store.getState();

    this.setState({
      name: storeState.user && storeState.user.name
        ? storeState.user.name
        : '',
      email: storeState.user && storeState.user.email
        ? storeState.user.email
        : '',
      language: storeState.user && storeState.user.language
          ? storeState.user.language
          : 'en_gb',
      isEmailVerified: storeState.user ? storeState.user.isEmailVerified : true
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleClose() {
    this.setState({
      isOpen: false,
    });

    if (appType === 'parent' && this.state.hasOwnProperty('isEmailVerified') && !this.state.isEmailVerified) {
      //If email is not verified redirect to dash
      window.location.hash = '';
      window.dispatchEvent(new CustomEvent(
          'parent:reload-app',
          {
            bubbles: true,
          }
      ));
    }
  }

  handleSaveClick() {
    const {
      cookies,
      t,
      enqueueSnackbar,
    } = this.props;

    axios
      .post(`${window.apiUrl}/settings`, qs.stringify({
        name: this.state.name,
        email: this.state.email,
        language: this.state.language,
      }))
      .then((response) => {
        if (response.data.success) {
          const userData = response.data.data;
          saveUserToStore(userData);

          enqueueSnackbar(t('You have successfully edited the user.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });
          this.reloadUserData();
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  handleDeleteClick() {
    this.setState({
      isDeletionDialogOpen: true,
    });
  }

  handleDeletionDialogClose() {
    this.setState({
      isDeletionDialogOpen: false,
    });
  }

  handleDeletionDialogConfirm() {
    const {
      cookies,
      t,
      enqueueSnackbar,
    } = this.props;

    axios
      .post(`${window.apiUrl}/delete`)
      .then((response) => {
        if (response.data.success) {
          logoutUser(cookies);

          enqueueSnackbar(t('You have successfully deleted the account.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });
          this.setState({
            isOpen: false,
            isDeletionDialogOpen: false,
          });
          window.location.href = rootUrl + '/' + appType + '/accountdeleted';
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      classes,
      t,
    } = this.props;
    const {
      isOpen,
      name,
      email,
      language,
      isDeletionDialogOpen,
    } = this.state;

    return (
      <>
        <Dialog
          fullScreen
          open={isOpen}
          onClose={this.handleClose}
          TransitionComponent={Transition}
          className="menu-settings-dialog"
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label={t('Close')}
                className="menu-settings-dialog-close-button"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h6"
                color="inherit"
              >
                {t('Account details')}
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent className={classes.contentWrapper}>
            <TextField
              id="name"
              label={t('Full name')}
              className={classes.textField}
              value={name}
              margin="normal"
              name="name"
              onChange={this.handleChange}
              autoComplete="off"
            />
            <TextField
              id="email"
              label={t('Email address')}
              type="email"
              className={classes.textField}
              value={email}
              margin="normal"
              name="email"
              autoComplete="off"
              onChange={this.handleChange}
            />
            <FormControl className={classes.textField}>
              <InputLabel htmlFor="language">
                {t('Language')}
              </InputLabel>
              <Select
                value={language}
                onChange={this.handleChange}
                inputProps={{
                  name: 'language',
                  id: 'language',
                }}
              >
                {Object.keys(languages).map(languageKey => (
                  <MenuItem
                    key={languageKey}
                    value={languageKey}
                  >
                    {t(languages[languageKey])}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSaveClick}
              className={`menu-settings-dialog-save-button ${classes.saveButton}`}
            >
              {t('Save')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleDeleteClick}
              className={`menu-password-dialog-delete-account-button ${classes.deleteButton}`}
            >
              {t('Delete account')}
            </Button>
          </DialogContent>
        </Dialog>
        <Dialog
          open={isDeletionDialogOpen}
          onClose={this.handleDeletionDialogClose}
          aria-labelledby="deletion-dialog-title"
          aria-describedby="deletion-dialog-description"
          className="account-deletion-confirmation-dialog"
        >
          <DialogTitle id="deletion-dialog-title">
            {t('Account deletion confirmation?')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="deletion-dialog-description">
              {t('Are you sure you want to delete your account? This action is irreversible.')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleDeletionDialogClose}
              color="primary"
              className="deletion-dialog-cancel-button"
            >
              {t('Cancel')}
            </Button>
            <Button
              onClick={this.handleDeletionDialogConfirm}
              color="primary"
              autoFocus
              className="deletion-dialog-confirm-button"
            >
              {t('Confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(withCookies(withSnackbar(withTranslation()(MenuSettingsDialog))));
